export const WorkingPeriodsMap = {
    hoursPerDay: 8,
    daysPerWeek: 5,
    weeksPerMonth: 4,
    monthsPerYear: 12,
};
